import { FC } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from 'recharts';

interface RtpTrendEntry {
  date: string;
  painNRS: number;
  confidenceScore: number;
  fearScore: number;
}

interface RtpNrsTrendChartProps {
  data: RtpTrendEntry[];
}

export const RtpNrsTrendChart: FC<RtpNrsTrendChartProps> = ({ data }) => {
  if (data.length === 0) {
    return <div style={{ padding: 16, textAlign: 'center', color: '#718096', fontSize: 13 }}>Nessun dato disponibile.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" tick={{ fontSize: 10 }} />
        <YAxis domain={[0, 10]} tick={{ fontSize: 10 }} />
        <Tooltip
          formatter={(value) => [`${Number(value)}/10`, 'NRS']}
          labelFormatter={(label) => `Data: ${label}`}
        />
        <ReferenceLine y={3} stroke="#E53E3E" strokeDasharray="5 5" label={{ value: 'Soglia', position: 'right', fontSize: 10 }} />
        <Line
          type="monotone"
          dataKey="painNRS"
          stroke="#E53E3E"
          name="NRS"
          strokeWidth={2}
          dot={{ r: 3, fill: '#E53E3E' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RtpNrsTrendChart;
